import type { FC } from 'react'

import Fuse from 'fuse.js'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import type { Policy } from '@/resources/ecom-policy'

import AllPoliciesCheckbox from './AllPoliciesCheckbox'
import PolicyListItem from './PolicyListItem'

import './styles.scss'

const PolicyList: FC<{
  searchQuery: string | null
  selectedPolicyIds: number[] | null
  policyList: Policy[]
  isMultipleChoice?: boolean
  onPolicySelect: (id: number) => void
  onPoliciesSelect?: (ids: number[] | null) => void
}> = ({
  searchQuery,
  selectedPolicyIds,
  policyList,
  isMultipleChoice,
  onPolicySelect,
  onPoliciesSelect,
}) => {
  const options = {
    keys: ['id', 'name', 'code', 'vendorName', 'coverAmount'],
  }

  const fuse = new Fuse(policyList, options)
  const policyListFiltered = searchQuery ? fuse.search(searchQuery) : []

  // todo: Fix bug of not showing the covered amount on mobile

  return (
    <div className="policies">
      <table>
        <thead>
          <tr>
            {onPoliciesSelect ? (
              <AllPoliciesCheckbox
                policyList={searchQuery ? policyListFiltered.map(({ item }) => item) : policyList}
                selectedPolicyIds={selectedPolicyIds}
                onPoliciesSelect={onPoliciesSelect}
              />
            ) : (
              <th />
            )}
            <th>
              <Translation id="Select all" />
            </th>

            <th className="is-mobile-hidden">
              <Translation id="description" />
            </th>

            <th className="is-mobile-hidden">
              <Translation id="Price list" />
            </th>

            <th className="number">
              <Translation id="covered amount" />
            </th>
          </tr>
        </thead>

        <tbody>
          {/* Hack for the bug of showing no results if the search query is empty https://github.com/krisk/Fuse/issues/229 */}
          {!searchQuery ? (
            <>
              {policyList.map(policyListItem => (
                <PolicyListItem
                  key={policyListItem.id}
                  isMultipleChoice={isMultipleChoice}
                  searchQuery={searchQuery || undefined}
                  selectedPolicyIds={selectedPolicyIds}
                  onPolicySelect={onPolicySelect}
                  {...policyListItem}
                />
              ))}
            </>
          ) : (
            <>
              {policyListFiltered.length ? (
                policyListFiltered.map(({ item: policyListItem }) => (
                  <PolicyListItem
                    key={policyListItem.id}
                    isMultipleChoice={isMultipleChoice}
                    searchQuery={searchQuery}
                    selectedPolicyIds={selectedPolicyIds}
                    onPolicySelect={onPolicySelect}
                    {...policyListItem}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <NoResults />
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default PolicyList
